import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Modal,
  Divider,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Button,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AlertComponent from "../Structure/AlertComponent";
import moment from "moment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

function FitlerModal({ showModal, setshowModal, title, destination, content }) {
  // 1) Data
  const theme = useTheme();
  const [date, setdate] = useState(moment());
  const [dateTo, setdateTo] = useState(moment().add("1", "M"));
  const [errorMessage, seterrorMessage] = useState("Error");
  const [showError, setshowError] = useState(false);

  // 2) UseEffects
  useEffect(() => {
    if (!showError) {
      setdate(moment());
      setdateTo(moment().add("1", "M"));
    }

    return;
  }, [showError]);

  // 3) Functions
  const handleChangeDate = (newValue) => {
    setdate(newValue);
    checkDatesFrom(newValue);
  };

  const handleChangeDateTo = (newValue) => {
    setdateTo(newValue);
    checkDatesTo();
  };

  const checkDatesFrom = (newValue) => {
    let check = newValue.isBefore(dateTo);
    if (check) {
      setshowError(false);
    } else {
      seterrorMessage("Date From cannot be greater than Date To");
      setshowError(true);
    }
  };
  const checkDatesTo = (newValue) => {
    let check = date.isBefore(newValue);
    if (check) {
      setshowError(false);
    } else {
      seterrorMessage("Date From cannot be greater than Date To");
      setshowError(true);
    }
  };

  return (
    <Modal
      open={showModal}
      onClose={() => {
        setshowModal(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {/* Header */}
        <div
          style={{
            background: theme.palette.primary.main,
            color: "white",
          }}
          className="rounded-xl px-3 pt-1 pb-3"
        >
          <Typography
            id="modal-modal-title"
            variant="h4"
            component="h2"
            className=""
          >
            {title}
          </Typography>
          <p>Filter and find the trips you need.</p>
        </div>

        {/* Body - Content */}
        <div className="px-2">
          <div className="p-2">
            <Grid container>
              <Grid item xs={12} mt={1}>
                <Grid container mb={1}>
                  <Grid item xs={12} mt={1}>
                    <DesktopDatePicker
                      label="Date From"
                      inputFormat="MM/DD/YYYY"
                      value={date}
                      onChange={handleChangeDate}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth size="small" />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} mt={2}>
                    <DesktopDatePicker
                      label="Date To"
                      inputFormat="MM/DD/YYYY"
                      value={dateTo}
                      onChange={handleChangeDateTo}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth size="small" />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>

        {/* Alert */}
        {showError && (
          <div className="px-4 mb-4 mt-1">
            <AlertComponent
              message={errorMessage}
              status={"Error"}
              setClose={setshowError}
            />
          </div>
        )}

        {/* Buttons */}
        <Divider />
        <Grid container className="pt-3 text-center mb-3">
          <Grid item xs={6}>
            <Button variant="contained" disabled={showError}>
              Confirm
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" onClick={() => setshowModal(false)}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 800,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  //padding: "10px 20px",
};

export default FitlerModal;
